import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URI } from 'src/environments/app.config';
import { Observable } from 'rxjs/Observable';
import { BaseService } from 'src/app/services/base.service';
import {Response} from 'src/app/services/models/response.model'
import { Tariff, TariffServiceModel } from './models/tariff/tariff.model';
import { TariffCreateRequest } from './models/tariff/tariff.create.request.model';
import { TariffUpdateRequest } from './models/tariff/tariff.update.request.model';

@Injectable()
export class TariffService extends BaseService {
  constructor(private _http: HttpClient) {
    super(_http);
    this.baseUrl =  API_URI.tariff;
  }

  getAllTariff(): Observable<Response<Tariff[]>> {
    const url = `/GetAllTariff`;
    return this.get(url)
    .map(result => new Response<Tariff[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  getTariffInfo(tariffID:number): Observable<Response<TariffServiceModel>> {
    const url = `/GetTariffInfo/`+tariffID;
    return this.get(url)
    .map(result => new Response<TariffServiceModel>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  search(tariffName:string,status?:number): Observable<Response<Tariff[]>> {
    tariffName = tariffName.trim();
    const url = `/Search?TariffName=`+tariffName+`&Status=`+status;
    return this.get(url)
    .map(result => new Response<Tariff[]>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  createTariff(tariffDetail: TariffCreateRequest): Observable<Response<Tariff>> {
    tariffDetail.TariffName = tariffDetail.TariffName.trim();
    return this.post(`/CreateTariff`, tariffDetail, {})
    .map(result => new Response<Tariff>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }

  updateTariff(tariffDetail: TariffUpdateRequest): Observable<Response<Tariff>> {
    tariffDetail.TariffName = tariffDetail.TariffName.trim();
    return this.post(`/UpdateTariff`, tariffDetail, {})    
    .map(result => new Response<Tariff>(result.code, result.message, result.responseData ))
    .catch(this.handleError);
  }
}